<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card class="form">
    <nb-card-header
      ><h4>
        {{ "dialogs.chatPreview.title" | translate }}
      </h4></nb-card-header
    >
    <nb-card-body>
      <nb-form-field>
        <label for="role" class="label col-sm-3 col-form-label">
          {{ "input.tutorSelect.label" | translate }}
        </label>

        <nb-select
          formControlName="botId"
          [status]="showInputError('role') ? 'danger' : 'basic'"
        >
          <nb-option
            *ngFor="let t of tutorService.tutors$.value"
            [value]="t.id"
            >{{ t.name }}</nb-option
          >
        </nb-select>
      </nb-form-field>
    </nb-card-body>
    <nb-card-footer>
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="dialogRef.close()"
      >
        {{ "buttons.cancel" | translate }}
      </button>
      <button
        type="submit"
        nbButton
        status="primary"
        [disabled]="!form.value.botId"
      >
        {{ "buttons.start" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
